import { render, staticRenderFns } from "./PriceingHomeOne.vue?vue&type=template&id=55156a52"
import script from "./PriceingHomeOne.vue?vue&type=script&lang=js"
export * from "./PriceingHomeOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports